import { B2bPeriodStats, B2bScopeStats } from '@/api/b2b';
import { useB2bStats } from '@/api/b2b/getStats';
import { Card } from '@/components/ui/elements/card';
import { KpiIndicator } from '@/features/reports/components/Graphs';

const PeriodTrio = ({ label, stats }: { label: string; stats: B2bPeriodStats }) => (
  <div>
    <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
      {label}
    </div>
    <div className="grid grid-cols-3 gap-2">
      <KpiIndicator name="Bookings" base={stats.bookings.base} comparison={stats.bookings.comparison} />
      <KpiIndicator
        name="Sales"
        format="currency"
        base={stats.sales.base}
        comparison={stats.sales.comparison}
      />
      <KpiIndicator name="Leads" base={stats.leads.base} comparison={stats.leads.comparison} />
    </div>
    {stats.sales.quota !== undefined && (
      <div className="text-xs text-muted-foreground">
        Quota ${(stats.sales.quota / 100).toLocaleString()} ·{' '}
        {Math.round((stats.sales.base / stats.sales.quota) * 100)}%
      </div>
    )}
  </div>
);

const ScopeCard = ({
  label,
  subtitle,
  scope,
  active,
  testid,
}: {
  label: string;
  subtitle: string;
  scope: B2bScopeStats | undefined;
  active?: boolean;
  testid: string;
}) => (
  <Card className={active ? 'border-l-4 border-l-green-600 p-4' : 'p-4'} data-testid={testid}>
    <div className="grid grid-cols-1 gap-4 @2xl:grid-cols-[8rem_1fr_1fr]">
      <div>
        <div className="text-lg font-semibold">{label}</div>
        <div className="text-xs text-muted-foreground">{subtitle}</div>
      </div>
      {scope ? (
        <>
          <PeriodTrio label="This Week" stats={scope.this_week} />
          <PeriodTrio label="This Month" stats={scope.this_month} />
        </>
      ) : (
        <div className="col-span-2 h-20 animate-pulse rounded bg-muted" />
      )}
    </div>
  </Card>
);

export const B2bStatsCards = () => {
  const { data } = useB2bStats();

  return (
    <div className="space-y-2">
      <ScopeCard testid="b2b-stats-all-nbe" label="All NBE" subtitle="All teams" scope={data?.all_nbe} />
      <ScopeCard
        testid="b2b-stats-team"
        label="B2B Team"
        subtitle="B2B reps only"
        scope={data?.b2b_team}
        active
      />
    </div>
  );
};
